<template lang="html">
  <div class="faq-wrapper-background">
    <div class="faq-wrapper">
      <div v-for="(faq, index) in list" :key="index" class="faq">
        <div @click="faq.open = !faq.open" class="faq-question">
          <div class="icon-wrapper">
            <img v-if="!faq.open" src="@/assets/icons/plus.png" alt="open faq icon">
            <img v-else src="@/assets/icons/minus.png" class="minus-icon" alt="open faq icon">
          </div>
          <span v-html="faq.question"></span>
        </div>
        <div v-if="faq.open" class="faq-answer" v-html="faq.answer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
export default {
  name: 'Faq',
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.getFaqs()
  },
  methods: {
    getFaqs () {
      api.getFaqs().then(res => {
        console.log(res.data.data);
        for (var i = 0; i < res.data.data.length; i++) {
          res.data.data[i].open = false
        }
        this.list = res.data.data
      }).catch(e => {
        console.log(e);
      })
    }
  },
  watch: {
    '$route.params.lang': {
      handler: function () {
        this.getFaqs()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.faq-wrapper-background {
  background: #F2F2F2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;

  .faq-wrapper {
    display: flex;
    height: 100%;
    max-width: 1600px;
    width: calc( 100% - 40px );
    margin: 0 auto;
    background: white;
    padding: 40px 40px;
    box-sizing: border-box;
    flex-direction: column;

    .faq {
      min-height: 70px;
      border-bottom: 1px solid #F2F2F2;

      .faq-question {
        font-weight: 600;
        font-size: 19px;
        line-height: 31px;
        letter-spacing: 0.06em;
        text-align: left;
        color: #4B4B4B;
        min-height: 70px;
        display: flex;
        align-items: center;
        cursor: pointer;

        .icon-wrapper {
          min-width: 30px;
          width: 30px;

          .minus-icon {
            margin-bottom: 5px;
          }
        }
      }
      .faq-answer {
        font-weight: 500;
        font-size: 15px;
        line-height: 22px;
        text-align: left;
        letter-spacing: 0.02em;
        color: #777777;
        margin-top: 10px;
        margin-bottom: 30px;
        padding-left: 30px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .faq-wrapper-background {
    .faq-wrapper {
       padding: 35px 35px;
      .faq{
        margin-bottom: 20px;
        .faq-question {
            font-weight: 600;
            font-size: 16px;
            text-align: left;
            color: #4B4B4B;
            display: flex;
            align-items: center;
            justify-content: initial;
            cursor: pointer;

            .icon-wrapper {
              min-width: 30px;
              width: 30px;
              padding-right: 5px;

              .minus-icon {
                margin-bottom: 5px;
              }
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 430px) {
    .faq-wrapper-background {
      .faq-wrapper {
        padding: 35px 20px;
        .faq{
          margin-bottom:15px;
          .faq-question {
            height: fit-content;
            cursor: pointer;
            .icon-wrapper {
              width: 30px;
              padding-right: 5px;

              .minus-icon {
                margin-bottom: 5px;
              }
            }
          }
        }
      }
    }
  }
</style>
